module.exports = __webpack_public_path__ + "static/media/204.101fcfd3.jpg";